import moment from 'moment';

export const USER_ROLE = {
  ADMIN: 'admin',
  TEACHER: 'teacher',
  STUDENT: 'member'
};

export const BILLING_CYCLE = {
  NONE: 'none',
  MONTHLY_4_SINGLE: 'monthly_4_single',
  MONTHLY_4_ANNUAL: 'monthly_4_annual',
  PREPAID: 'prepaid',
  PREPAID_3: 'prepaid_3',
  PREPAID_6: 'prepaid_6',
  PREPAID_8: 'prepaid_8',
  PREPAID_12: 'prepaid_12',
  PREPAID_20: 'prepaid_20',
  MONTHLY: 'monthly',
  MONTHLY_6: 'monthly_6',
  MONTHLY_8: 'monthly_8',
  MONTHLY_8_SINGLE: 'monthly_8_single',
  MONTHLY_8_ANNUAL: 'monthly_8_annual',
  MONTHLY_12: 'monthly_12',
  MONTHLY_15_SINGLE: 'monthly_15_single',
  MONTHLY_15_ANNUAL: 'monthly_15_annual',
  MONTHLY_20: 'monthly_20'
};

export const DEFAULT_BILLING_CYCLE = BILLING_CYCLE.MONTHLY_15_ANNUAL;

export const QUERY_PARAM_FOR_BILLING_CYCLE = {
  $4_MONTH: '4_month',
  $8_MONTH: '8_month',
  $15_MONTH: '15_month',
  $4_ANNNUAL: '4_annual',
  $8_ANNNUAL: '8_annual',
  $15_ANNNUAL: '15_annual',
};

export const PLAN_LIMIT = {
  NONE: 'None',
  HOURS_2: '2',
  HOURS_4: '4',
  HOURS_6: '6',
  HOURS_7: '7',
  HOURS_8: '8',
  HOURS_10: '10',
  HOURS_15: '15'
};

export const DEFAULT_PLAN_LIMIT = PLAN_LIMIT.HOURS_15;

export const PLAN_TYPE = {
  NONE: 'none',
  GO: 'GO',
  X: 'X'
};

export const STRIPE_MODE = {
  TEST: 'test',
  LIVE: 'live'
};

export const MAX_PAUSE_WEEKS = 4;

export const PLAN_CATEGORY = {
  NONE: 'none',
  LANGUAGE: 'language',
  ACADEMIC: 'academic'
};

export const SERVICE_NAMES = [
  'Spanish',
  'Italian',
  'English',
  'French',
  'German',
  'Mandarin',
  'Arabic',
  'Japanese',
  'Portuguese',
  'Russian',
  'Algebra',
  'Calculus',
  'Pre-Calculus',
  'Statistics',
  'Geometry',
  'Trigonometry',
  'Elementary Math'
];

export const ISSUE_REFUND_STATUS = {
  APPROVED_BY_TEACHER: 'approved_by_teacher',
  APPROVED_BY_DELAY: 'approved_by_delay',
  DISPUTED_BY_TEACHER: 'disputed_by_teacher',
  APPROVED_BY_RYPE: 'approved_by_rype',
  DENIED_BY_RYPE: 'denied_by_rype'
};

export const TEACHER_MENU = [
  {
    title: 'Home',
    path: '/teacher/home',
    icon: 'home'
  },
  {
    title: 'Schedule',
    path: '/teacher/schedule',
    icon: 'schedule',
    submenu: [
      { title: 'Reservations', path: '/teacher/schedule/reservations' },
      { title: 'Availability', path: '/teacher/schedule/availability' },
      { title: 'Listing', path: '/teacher/schedule/listings' }
    ]
  },
  /* {
    title: 'Payments',
    path: '/teacher/payments',
    icon: 'payment'
  }, */
  {
    title: 'Settings',
    path: '/teacher/settings',
    icon: 'setting',
    submenu: [
      { title: 'Edit Profile', path: '/teacher/settings/profile' },
      { title: 'Photo', path: '/teacher/settings/photo' },
      { title: 'Calendars', path: '/teacher/settings/calendar-sync' },
      { title: 'Help', path: '/teacher/settings/help' }
      /* { title: 'Billing', path: '/teacher/settings/billing' } */
    ]
  }
];

const slots = [];
const dateIter = moment().startOf('Day');
let minuteIter = 0;
while (minuteIter < 49) {
  let label = dateIter.format('h:mm A');
  if (minuteIter === 0) {
    label = `${label} (start of day)`;
  } else if (minuteIter === 48) {
    label = `${label} (end of day)`;
  }
  slots.push({
    value: minuteIter * 30,
    label
  });
  minuteIter += 1;
  dateIter.add(30, 'minutes');
}
export const TIME_SLOTS = slots;

export const UPSELL_PRICE = 4700;

export const RESERVATIONS_MODE = {
  UPCOMING: 'upcoming',
  PENDING: 'pending',
  ALL: 'all'
};



// WEBPACK FOOTER //
// ./src/config/constants.js